exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnswersType7{position:relative}.AnswersType7 .blockedAnswer{width:100%;height:100%;z-index:10;position:absolute;top:0;left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/components/AnswersType7/style.scss
// module id = 5238
// module chunks = 0